module.exports = __webpack_public_path__ + "img/code.d1b74444.png";